import { render } from "./anc_medical_history.vue?vue&type=template&id=6fedc79a&scoped=true"
import script from "./anc_medical_history.vue?vue&type=script&lang=js"
export * from "./anc_medical_history.vue?vue&type=script&lang=js"

import "./anc_medical_history.vue?vue&type=style&index=0&id=6fedc79a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fedc79a"]])

export default __exports__